import React, { useState, useCallback } from "react";
import NotificationContext, {
  NotificationVariant,
  NotificationContent,
  ErrorInfo
} from "./RHNotificationContext";
import RHNotification from "./RHNotification";
import { errorParse, getErrorInfo } from "utils/error-handlers/error-parse";

const RHNotificationProvider = ({ children }) => {
  const [display, setDisplay] = useState(false);
  const [variant, setVariant] = useState<NotificationVariant>("success");
  const [content, setContent] = useState<NotificationContent>("");
  const [errorInfo, setErrorInfo] = useState<ErrorInfo>();
  const [title, setTitle] = useState("");
  const closeNotificationModal = useCallback((onClose = () => {}) => {
    if (typeof onClose === "function") onClose();
    setDisplay(false);
  }, []);

  const showNotificationModal = useCallback(
    (
      title: string,
      content?: NotificationContent,
      variant?: NotificationVariant,
      errorInfo?: ErrorInfo
    ) => {
      setTitle(title);
      setContent(
        typeof content === "string" ? errorParse(content || "") : content
      );
      setErrorInfo(getErrorInfo(errorInfo));
      setVariant(variant || "success");
      setDisplay(true);
    },
    []
  );

  return (
    <NotificationContext.Provider
      value={{
        showNotificationModal,
        closeNotificationModal
      }}
    >
      {children}
      {display && (
        <RHNotification
          open={display}
          handleClose={closeNotificationModal}
          title={title}
          content={content}
          variant={variant}
          errorInfo={errorInfo}
        />
      )}
    </NotificationContext.Provider>
  );
};

export default RHNotificationProvider;
